import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Plugins
import { FacebookModule } from 'ngx-facebook';
import { RecaptchaModule } from 'ng-recaptcha';
// import { TwsitterService } from 'ng2-twitter';
import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { RootScreenComponent } from './root-screen/root-screen.component';
import { WelcomeAlwaysonComponent } from './welcome-alwayson/welcome-alwayson.component';
import { RouterModule, Routes } from '@angular/router';
import { LoaderComponent } from './loader/loader.component';
import { NoticeOfPrivacyComponent } from './notice-of-privacy/notice-of-privacy.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { WithoutdecimalsPipe } from './withoutdecimals.pipe';
import { PaymentDeclinedModalComponent } from './payment-declined-modal/payment-declined-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    FooterComponent,
    HomeComponent,
    RootScreenComponent,
    WelcomeAlwaysonComponent,
    LoaderComponent,
    NoticeOfPrivacyComponent,
    TermsAndConditionsComponent,
    WithoutdecimalsPipe,
    PaymentDeclinedModalComponent,
  ],
  imports: [
    BrowserModule,
    FacebookModule.forRoot(),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule.forRoot(),
  ],
  exports: [],
  providers: [],
  bootstrap: [AppComponent, FooterComponent]
})
export class AppModule { }
